export default [
  {
    path: "/candidatos-no-contratados",
    component: () =>
      import(
        /* webpackChunkName: "candidatosNoContratados" */ "./layout.vue"
      ),
    children: [
      {
        path: "",
        name: "candidatos-no-contratados-lista",
        component: () =>
          import(
            /* webpackChunkName: "candidatosNoContratados" */ "./views/ListaCandidatosNoContratados.vue"
          ),
      },
      {
        path: "detalle/:id",
        name: "detalle-candidatos-no-contratados-lista",
        component: () =>
          import(
            /* webpackChunkName: "candidatosNoContratados" */ "./views/CandidatosNoContratados.vue"
          ),
      }
    ],
  },
];
